// // AddRewardsCouponFormWrapper.tsx
// import { Formik, FormikHelpers, Form } from 'formik';
// import React from 'react';
// import { RewardsCouponFormValues } from '../../models/RewardsCoupon.model';
// import RewardsCouponFormLayout from '../../components/RewardsCouponFormLayout';
// import { object, string, number, array, boolean, mixed, ref } from 'yup';
// import { useGetOutletQuery } from 'src/modules/Outlet/service/OutletServices';
// import { useFetchData } from 'src/hooks/useFetchData';
// import { showToast } from 'src/utils/showToaster';
// import { useAddRewardsCouponMutation } from '../../service/RewardsCouponServices';
// import { useNavigate } from 'react-router-dom';

// type Props = {};

// const weekdays = [
//   'Monday',
//   'Tuesday',
//   'Wednesday',
//   'Thursday',
//   'Friday',
//   'Saturday',
//   'Sunday',
// ];

// const AddRewardsCouponFormWrapper = (props: Props) => {
//   const navigate = useNavigate();
//   const { data } = useFetchData(useGetOutletQuery, {});
//   const [addRewardsCoupon] = useAddRewardsCouponMutation();


  
//   const initialValues: RewardsCouponFormValues = {
//     couponType: "NORMAL",
//     rewardName: '',
//     rewardsPoint: '',
//     rewardType: 'AMOUNT',
//     rewardValue: 0,
//     minimumSpend: 0,
//     maximumDiscount: 0,
//     couponCode: '',
//     branchId: [],
//     serviceId: [],
//     validDays: [],
//     startTime: '09:00',
//     endTime: '18:00',
//     validFrom: null,
//     validTill: null,
//     description: '',
//     isActive: true,
//     status: 'active',
//   };

//   const validationSchema = object().shape({

//     couponType: string()
//       .required('Reward type is required')
//       .oneOf(["REWARD", "PROMOTION", "GIFTCARD", "NORMAL"], 'Invalid reward type'),
//     rewardName: string()
//       .required('Reward name is required')
//       .min(3, 'Minimum 3 characters')
//       .max(100, 'Maximum 100 characters'),

//     rewardsPoint: string()
//       .required('Rewards point is required')
//       .matches(/^[0-9]+$/, 'Must be a valid number'),

//     rewardType: string()
//       .required('Reward type is required')
//       .oneOf(['AMOUNT', 'PERCENTAGE'], 'Invalid reward type'),

//     rewardValue: number()
//       .required('Reward value is required')
//       .min(0, 'Cannot be negative')
//       .when('rewardType', {
//         is: 'PERCENTAGE',
//         then: (schema) => schema.min(1, 'Must be at least 1%').max(100, 'Cannot exceed 100%'),
//         otherwise: (schema) => schema.min(0, 'Cannot be negative'),
//       }),

//    minimumSpend: number()
//   .transform((value, originalValue) =>
//     originalValue === "" ? undefined : value
//   )
//   .required("Minimum spend is required")
//   .min(0, "Cannot be negative"),

// maximumDiscount: number()
//   .transform((value, originalValue) =>
//     originalValue === "" ? undefined : value
//   )
//   .required("Maximum discount is required")
//   .min(0, "Cannot be negative"),

//     couponCode: string()
//       .required('Coupon code is required')
//       .matches(/^[A-Z0-9]+$/, 'Must be uppercase letters and numbers only')
//       .min(4, 'Minimum 4 characters')
//       .max(20, 'Maximum 20 characters'),

//     // BranchId - Required hataye
//     branchId: array()
//       .nullable()
//       .optional(), // Not required anymore

//     // ServiceId - Required hataye
//     serviceId: array()
//       .nullable()
//       .optional(), // Not required anymore

//     validDays: array()
//       .min(1, 'Select at least one valid day')
//       .of(string().oneOf(weekdays)),

//     startTime: string()
//       .required('Start time is required')
//       .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Invalid time format'),

//     endTime: string()
//       .required('End time is required')
//       .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Invalid time format')
//       .test('is-after-start', 'End time must be after start time', function (value) {
//         const { startTime } = this.parent;
//         if (!startTime || !value) return true;
//         return value > startTime;
//       }),

//     validFrom: mixed()
//       .test('valid-date', 'Valid from date is required', function (value) {
//         if (!value) return false;
//         const date = new Date(value as string | Date);
//         return !isNaN(date.getTime());
//       })
//       .test('future-date', 'Date must be in the future', function (value) {
//         if (!value) return false;
//         const date = new Date(value as string | Date);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return date >= today;
//       }),

//     validTill: mixed()
//       .test('valid-date', 'Valid till date is required', function (value) {
//         if (!value) return false;
//         const date = new Date(value as string | Date);
//         return !isNaN(date.getTime());
//       })
//       .test('after-valid-from', 'Valid till must be after valid from', function (value) {
//         const { validFrom } = this.parent;
//         if (!value || !validFrom) return false;
//         const fromDate = new Date(validFrom as string | Date);
//         const tillDate = new Date(value as string | Date);
//         return tillDate > fromDate;
//       }),

//     description: string()
//       .max(500, 'Maximum 500 characters')
//       .nullable(),

//     isActive: boolean(),
//     status: string(),
//   });

//   const handleSubmit = (
//     values: RewardsCouponFormValues,
//     { resetForm, setSubmitting }: FormikHelpers<RewardsCouponFormValues>,
//   ) => {
//     const formattedValues = {
//       couponType:values?.couponType,
//       rewardName: values.rewardName,
//       rewardsPoint: values.rewardsPoint,
//       rewardType: values.rewardType,
//       rewardValue: values.rewardValue,
//       minimumSpend: values.minimumSpend,
//       maximumDiscount: values.maximumDiscount,
//       couponCode: values.couponCode.toUpperCase(),
//       branchId: Array.isArray(values.branchId)
//         ? values.branchId.map((branch: any) =>
//           typeof branch === 'object' ? branch._id : branch
//         )
//         : [],
//       serviceId: Array.isArray(values.serviceId)
//         ? values.serviceId.map((service: any) =>
//           typeof service === 'object' ? service._id : service
//         )
//         : [],
//       validDays: values.validDays || [],
//       startTime: values.startTime,
//       endTime: values.endTime,
//       validFrom: values.validFrom ? new Date(values.validFrom).toISOString() : null,
//       validTill: values.validTill ? new Date(values.validTill).toISOString() : null,
//       description: values.description || '',
//       isActive: values.isActive,
//       status: values.isActive ? 'active' : 'inactive',
//     };

//     addRewardsCoupon(formattedValues).then((res: any) => {
//       if (res?.error) {
//         showToast('error', res?.error?.data?.message || 'Failed to create coupon');
//       } else {
//         if (res?.data?.status) {
//           showToast('success', res?.data?.message || 'Coupon created successfully!');
//           resetForm();
//           navigate('/rewards-coupon');
//         } else {
//           showToast('error', res?.data?.message || 'Failed to create coupon');
//         }
//       }
//       setSubmitting(false);
//     });
//   };

//   return (
//     <Formik<RewardsCouponFormValues>
//       initialValues={initialValues}
//       onSubmit={handleSubmit}
//       validationSchema={validationSchema}
//       enableReinitialize
//     >
//       {(formikProps) => (
//         <Form className="h-full">
//           <RewardsCouponFormLayout
//             formikProps={formikProps}
//             formType="ADD"
//             onCancel={() => navigate('/rewards-coupon')}
//           />
//         </Form>
//       )}
//     </Formik>
//   );
// };

// export default AddRewardsCouponFormWrapper;

// AddRewardsCouponFormWrapper.tsx

import { Formik, FormikHelpers, Form } from 'formik';
import React from 'react';
import { RewardsCouponFormValues } from '../../models/RewardsCoupon.model';
import RewardsCouponFormLayout from '../../components/RewardsCouponFormLayout';
import { object, string, number, array, boolean, mixed } from 'yup';
import { showToast } from 'src/utils/showToaster';
import { useAddRewardsCouponMutation } from '../../service/RewardsCouponServices';
import { useNavigate } from 'react-router-dom';

type Props = {};

const weekdays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const AddRewardsCouponFormWrapper = (props: Props) => {
  const navigate = useNavigate();

  const [addRewardsCoupon] = useAddRewardsCouponMutation();

  const initialValues: RewardsCouponFormValues = {
    couponType: 'NORMAL',
    rewardName: '',
    rewardsPoint: '',
    rewardType: 'AMOUNT',
    rewardValue: 0,
    minimumSpend: 0,
    maximumDiscount: 0,
    giftCardAmount: 0,
    couponCode: '',
    branchId: [],
    serviceId: [],
    validDays: [],
    startTime: '09:00',
    endTime: '18:00',
    validFrom: null,
    validTill: null,
    description: '',
    isActive: true,
    status: 'active',
    isComplimentaryCoupon:false
  };

  const validationSchema = object().shape({
    couponType: string()
      .required('Coupon type is required')
      .oneOf(
        [
          'REWARD',
          'PROMOTION',
          'GIFTCARD',
          'SERVICE_GIFTCARD',
          'NORMAL',
        ],
        'Invalid coupon type',
      ),

    rewardName: string()
      .required('Name is required')
      .min(3, 'Minimum 3 characters')
      .max(100, 'Maximum 100 characters'),

    rewardsPoint: string().when('couponType', {
      is: 'REWARD',
      then: (schema) =>
        schema
          .required('Rewards point is required')
          .matches(/^[0-9]+$/, 'Must be a valid number'),
      otherwise: (schema) => schema.notRequired(),
    }),

    rewardType: string().when('couponType', {
      is: (couponType: string) =>
        ['REWARD', 'PROMOTION', 'NORMAL'].includes(couponType),
      then: (schema) =>
        schema
          .required('Reward type is required')
          .oneOf(
            ['AMOUNT', 'PERCENTAGE'],
            'Invalid reward type',
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

    rewardValue: number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when('couponType', {
        is: (couponType: string) =>
          ['REWARD', 'PROMOTION', 'NORMAL'].includes(couponType),
        then: (schema) =>
          schema
            .required('Reward value is required')
            .min(0, 'Cannot be negative')
            .when('rewardType', {
              is: 'PERCENTAGE',
              then: (percentageSchema) =>
                percentageSchema
                  .min(1, 'Must be at least 1%')
                  .max(100, 'Cannot exceed 100%'),
              otherwise: (amountSchema) =>
                amountSchema.min(0, 'Cannot be negative'),
            }),
        otherwise: (schema) => schema.notRequired(),
      }),

    minimumSpend: number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when('couponType', {
        is: (couponType: string) =>
          ['REWARD', 'PROMOTION', 'NORMAL'].includes(couponType),
        then: (schema) =>
          schema
            .required('Minimum spend is required')
            .min(0, 'Cannot be negative'),
        otherwise: (schema) => schema.notRequired(),
      }),

    maximumDiscount: number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when('couponType', {
        is: (couponType: string) =>
          ['REWARD', 'PROMOTION', 'NORMAL'].includes(couponType),
        then: (schema) =>
          schema
            .required('Maximum discount is required')
            .min(0, 'Cannot be negative'),
        otherwise: (schema) => schema.notRequired(),
      }),

    giftCardAmount: number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when('couponType', {
        is: (couponType: string) =>
          ['GIFTCARD', 'SERVICE_GIFTCARD'].includes(couponType),
        then: (schema) =>
          schema
            .required('Gift card amount is required')
            .min(1, 'Gift card amount must be greater than 0'),
        otherwise: (schema) => schema.notRequired(),
      }),

    couponCode: string()
      .required('Coupon code is required')
      .matches(
        /^[A-Z0-9]+$/,
        'Must be uppercase letters and numbers only',
      )
      .min(4, 'Minimum 4 characters')
      .max(20, 'Maximum 20 characters'),

    branchId: array()
      .nullable()
      .optional(),

    // serviceId: array()
    //   .nullable()
    //   .when('couponType', {
    //     is: 'SERVICE_GIFTCARD',
    //     then: (schema) =>
    //       schema
    //         .required('Please select at least one service')
    //         .min(1, 'Please select at least one service'),
    //     otherwise: (schema) => schema.optional(),
    //   }),

    validDays: array()
      .required('Please select at least one valid day')
      .min(1, 'Select at least one valid day')
      .of(string().oneOf(weekdays)),

    startTime: string()
      .required('Start time is required')
      .matches(
        /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
        'Invalid time format',
      ),

    endTime: string()
      .required('End time is required')
      .matches(
        /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
        'Invalid time format',
      )
      .test(
        'is-after-start',
        'End time must be after start time',
        function (value) {
          const { startTime } = this.parent;

          if (!startTime || !value) {
            return true;
          }

          return value > startTime;
        },
      ),

    validFrom: mixed()
      .test(
        'valid-date',
        'Valid from date is required',
        function (value) {
          if (!value) return false;

          const date = new Date(value as string | Date);

          return !isNaN(date.getTime());
        },
      )
      .test(
        'future-date',
        'Date must be in the future',
        function (value) {
          if (!value) return false;

          const date = new Date(value as string | Date);

          const today = new Date();

          today.setHours(0, 0, 0, 0);

          return date >= today;
        },
      ),

    validTill: mixed()
      .test(
        'valid-date',
        'Valid till date is required',
        function (value) {
          if (!value) return false;

          const date = new Date(value as string | Date);

          return !isNaN(date.getTime());
        },
      )
      .test(
        'after-valid-from',
        'Valid till must be after valid from',
        function (value) {
          const { validFrom } = this.parent;

          if (!value || !validFrom) return false;

          const fromDate = new Date(
            validFrom as string | Date,
          );

          const tillDate = new Date(
            value as string | Date,
          );

          return tillDate > fromDate;
        },
      ),

    description: string()
      .max(500, 'Maximum 500 characters')
      .nullable(),

    isActive: boolean(),

    status: string(),
  });

  const handleSubmit = (
    values: RewardsCouponFormValues,
    {
      resetForm,
      setSubmitting,
    }: FormikHelpers<RewardsCouponFormValues>,
  ) => {
    const isGiftCard =
      values.couponType === 'GIFTCARD' ||
      values.couponType === 'SERVICE_GIFTCARD';

    const isReward =
      values.couponType === 'REWARD';

    const isDiscountCoupon =
      values.couponType === 'REWARD' ||
      values.couponType === 'PROMOTION' ||
      values.couponType === 'NORMAL';

    const branchIds = Array.isArray(values.branchId)
      ? values.branchId
          .map((branch: any) =>
            typeof branch === 'object'
              ? branch?._id
              : branch,
          )
          .filter(Boolean)
      : [];

    const serviceIds = Array.isArray(values.serviceId)
      ? values.serviceId
          .map((service: any) =>
            typeof service === 'object'
              ? service?._id
              : service,
          )
          .filter(Boolean)
      : [];

    const formattedValues = {
      couponType: values.couponType,

      rewardName: values.rewardName,

      rewardsPoint: isReward
        ? values.rewardsPoint
        : 0,

      rewardType: isDiscountCoupon
        ? values.rewardType
        : 'AMOUNT',

      rewardValue: isDiscountCoupon
        ? Number(values.rewardValue || 0)
        : 0,

      minimumSpend: isDiscountCoupon
        ? Number(values.minimumSpend || 0)
        : 0,

      maximumDiscount: isDiscountCoupon
        ? Number(values.maximumDiscount || 0)
        : 0,

      giftCardAmount: isGiftCard
        ? Number(values.giftCardAmount || 0)
        : 0,

      // balanceAmount: isGiftCard
      //   ? Number(values.giftCardAmount || 0)
      //   : 0,

      couponCode: values.couponCode
        ? values.couponCode.toUpperCase()
        : '',

      branchId: branchIds,

      serviceId: serviceIds,

      validDays: values.validDays || [],

      startTime: values.startTime,

      endTime: values.endTime,

      validFrom: values.validFrom
        ? new Date(values.validFrom).toISOString()
        : null,

      validTill: values.validTill
        ? new Date(values.validTill).toISOString()
        : null,

      description: values.description || '',

      isActive: values.isActive,

      status: values.isActive
        ? 'active'
        : 'inactive',
        isComplimentaryCoupon:values?.isComplimentaryCoupon
    };

    addRewardsCoupon(formattedValues)
      .then((res: any) => {
        if (res?.error) {
          showToast(
            'error',
            res?.error?.data?.message ||
              'Failed to create coupon',
          );
          return;
        }

        if (res?.data?.status) {
          showToast(
            'success',
            res?.data?.message ||
              'Coupon created successfully!',
          );

          resetForm();

          navigate('/rewards-coupon');
        } else {
          showToast(
            'error',
            res?.data?.message ||
              'Failed to create coupon',
          );
        }
      })
      .catch((error: any) => {
        showToast(
          'error',
          error?.message ||
            'Something went wrong while creating coupon',
        );
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Formik<RewardsCouponFormValues>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {(formikProps) => (
        <Form className="h-full">
          <RewardsCouponFormLayout
            formikProps={formikProps}
            formType="ADD"
            onCancel={() =>
              navigate('/rewards-coupon')
            }
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddRewardsCouponFormWrapper;